// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForgotPasswordVerification_forgotPasswordVerificationContainer__Kx9iy .ForgotPasswordVerification_otpInputClassName__aNjRx {
  border-radius: 10px;
  caret-color: var(--emarald-green-color);
}
.ForgotPasswordVerification_forgotPasswordVerificationContainer__Kx9iy .ForgotPasswordVerification_otpWrapperClassName__hvWD- {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/component/pages/service-provider-admin/auth/forgot-password-otp-verification/ForgotPasswordVerification.module.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;EACA,uCAAA;AAAR;AAEM;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;AAAR","sourcesContent":[".forgotPasswordVerificationContainer{\n    .otpInputClassName {\n        border-radius: 10px;\n        caret-color: var(--emarald-green-color);\n      }\n      .otpWrapperClassName {\n        display: flex;\n        justify-content: flex-start;\n        margin-bottom: 10px;\n      }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"forgotPasswordVerificationContainer": `ForgotPasswordVerification_forgotPasswordVerificationContainer__Kx9iy`,
	"otpInputClassName": `ForgotPasswordVerification_otpInputClassName__aNjRx`,
	"otpWrapperClassName": `ForgotPasswordVerification_otpWrapperClassName__hvWD-`
};
export default ___CSS_LOADER_EXPORT___;
